import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import location_45guard_45global from "/vercel/path0/middleware/location_guard.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  location_45guard_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-guard": () => import("/vercel/path0/middleware/auth_guard.ts")
}